import { FunctionalComponent, h } from 'preact';

import { TelephoneInputTemplatePropsInterface } from 'common/module/telephone-input/template-props.interface';

export const TelephoneInputTemplate: FunctionalComponent<TelephoneInputTemplatePropsInterface> = (props) => (
  <div className={`telephone__input-container ${props.hasError ? ' telephone__input-container--invalid' : ''}`}>
    <div className='telephone__country-selected' onClick={props.onClickToggleCountryList}>
      <span
        className={`telephone__country-flag telephone__country-flag--${props.selectedCountry} telephone__country-selected-flag`}
      />
      <span
        className={`telephone__country-selected-arrow ${
          props.showCountriesList ? 'telephone__country-selected-arrow--up' : ''
        }`}
      />
    </div>
    <div className='telephone__input-field-container'>
      <input
        className='input telephone__input-field'
        placeholder={props.placeholder}
        value={!props.isLoading ? props.value : ''}
        name={props.name}
        onChange={props.onChange}
        onBlur={props.onBlur}
        onInput={props.onInput}
        disabled={props.isLoading}
      />
    </div>
    <div className={`telephone__country-list ${props.showCountriesList ? 'telephone__country-list--show' : ''}`}>
      {props.countriesList.map((item) => (
        <div
          className={`telephone__country-list-item
          ${item.countryCode === props.selectedCountry ? 'telephone__country-list-item--selected' : ''}`}
          onClick={(e: Event) => {
            props.onClickChangeCountryCode(item.countryCode);
          }}
        >
          <span
            className={`telephone__country-flag telephone__country-flag--${item.countryCode} telephone__country-list-flag`}
          />
          {item.name} (<span className='telephone__country-list-code'>+{item.phoneCode}</span>)
        </div>
      ))}
    </div>
  </div>
);
